//import _ from "lodash";
import {
  Button,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Typography,
  useTheme,
} from "@mui/material";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import Box from "@mui/material/Box";
//import { useProfile } from '../../api/hooks';
import { useNavigate } from "react-router-dom";
import CheckIcon from "@mui/icons-material/Check";
import KeyboardArrowRightIcon from "@mui/icons-material/KeyboardArrowRight";
import GoogleIcon from "@mui/icons-material/Google";
import TaskOutlinedIcon from "@mui/icons-material/TaskOutlined";
import CurrencyExchangeIcon from "@mui/icons-material/CurrencyExchange";
import LanguageOutlinedIcon from "@mui/icons-material/LanguageOutlined";
import DevicesIcon from "@mui/icons-material/Devices";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";
import VerifiedUserOutlinedIcon from "@mui/icons-material/VerifiedUserOutlined";
import PaymentsOutlinedIcon from "@mui/icons-material/PaymentsOutlined";
import ReceiptOutlinedIcon from "@mui/icons-material/ReceiptOutlined";
import PriceCheckOutlinedIcon from "@mui/icons-material/PriceCheckOutlined";
import UndoIcon from "@mui/icons-material/Undo";
import QueryStatsIcon from "@mui/icons-material/QueryStats";
import BrightnessMediumOutlinedIcon from "@mui/icons-material/BrightnessMediumOutlined";
import CheckCircleOutlinedIcon from "@mui/icons-material/CheckCircleOutlined";
import HeightIcon from "@mui/icons-material/Height";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import { useMedia } from "react-use";
import { Trans } from "react-i18next";

export const FrontPage = () => {
  const navigate = useNavigate();

  //  const { profile } = useProfile();
  //  const isSignedIn = !!profile;

  const theme = useTheme();
  const isDarkTheme = useMedia("(prefers-color-scheme: dark)");

  const methodLogoHeight = "74px";
  const methodLogoRadius = "8px";
  const methodBackground = "#fff"; //"#eff2f5";

  function createData(name: string, amount: string) {
    return { name, amount };
  }

  const rows = [
    createData("Admission", "Waived"),
    createData("24/7 customer support", "Waived"),
    createData("24/7 technical support", "Waived"),
    createData("Mobile money and wallet payments", "1.5%"),
    createData("Bank card payments", "3.0%"),
  ];

  return (
    <Box
      sx={{
        position: "relative",
        overflow: "hidden",
        padding: 0,
        background: isDarkTheme ? theme.palette.background.default : "#fff",
        //       p: '56px 16px 16px',
        m: "-56px -16px -16px",
      }}
    >
      <Box
        className="hero"
        sx={{
          position: "absolute",
          top: 0,
          left: 0,
          width: "100%",
          zIndex: 0,
        }}
      >
        <Box
          className="hero-gradient"
          sx={{
            display: "flex",
            flexDirection: "column",
            justifyContent: "center",
            alignItems: "center",
            height: {
              xs: "62vw",
              sm: "320px",
              md: "340px",
              lg: "360px",
              xl: "380",
            },
            backgroundColor: "#333",
            backgroundSize: "cover",
            backgroundPosition: "50% 50%",
            textAlign: "left",
            clipPath: {
              xs: "polygon(0 0, 2160px 0, 2160px -40%, 0 100%)",
              sm: "polygon(0 0, 2160px 0, 2160px 20%, 0 100%)",
            },
          }}
        ></Box>
      </Box>
      <Box
        className="front-page page"
        sx={{
          position: "relative",
          maxWidth: "1080px",
          margin: "auto",
          width: "100%",
          flexGrow: 1,
          mt: { xs: "56px", sm: "56px" },
          padding: "0 8px",
          zIndex: 1,
        }}
      >
        <Box
          sx={{ display: "flex", flexDirection: { xs: "column", md: "row" } }}
        >
          <Box
            sx={{
              p: { xs: "0 16px", sm: "0 16px 0 32px" },
              maxWidth: { xs: "100%", md: "640px" },
            }}
          >
            <Box
              sx={{
                width: "100%",
                padding: { xs: "64px 0px 24px", sm: "0px" },
                fontSize: { xs: "13vw", sm: "12vw", md: "6vw", xl: "80px" },
                lineHeight: "1.04",
                letterSpacing: "-0.015em",
                fontWeight: "600",
                color: isDarkTheme ? "#fff" : "#11143a",
                mt: { xs: "0px", sm: "32px" },
                mb: { xs: "16px", sm: "24px" },

                zIndex: 10,
              }}
            >
              {<Trans>frontpage-hero-h1</Trans>}
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  mb: "4px",
                }}
              >
                <Typography>
                  Use Spidipay&apos;s software and APIs to accept payments, so
                  you can:
                </Typography>
                <List
                  sx={{
                    mt: 0,
                  }}
                >
                  <ListItem sx={{ p: "0 0 0 16px" }}>
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Get paid fast with any popular payment method and let
                      Spidipay handle payment related obligations for you
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: "0 0 0 16px" }}>
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Provide the best payment experience to your customers and
                      improve conversion from international customers
                    </ListItemText>
                  </ListItem>
                  <ListItem sx={{ p: "0 0 0 16px" }}>
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Focus critical developer resources on your core business
                      and launch new products faster with minimal payments code
                    </ListItemText>
                  </ListItem>
                  {/*                 <ListItem sx={{ p: "0 0 0 16px" }}>
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Launch new products faster with minimal payments code
                    </ListItemText>
                  </ListItem> */}

                  {/*                   <ListItem sx={{ p: "0 0 0 16px" }}>
                    <ListItemIcon sx={{ minWidth: "40px" }}>
                      <CheckIcon />
                    </ListItemIcon>
                    <ListItemText>
                      Improve conversion from international customers
                    </ListItemText>
                  </ListItem> */}
                </List>
              </Box>
              <Box
                sx={{
                  display: "flex",
                  flexDirection: "row",
                  justifyContent: { xs: "left", sm: "left" },
                  alignItems: "center",
                  mt: "24px",
                }}
              >
                <Button
                  variant="contained"
                  size="small"
                  endIcon={<KeyboardArrowRightIcon />}
                  sx={{ fontWeight: "bold" }}
                  onClick={() => {
                    navigate("/signin");
                  }}
                >
                  Start now
                </Button>{" "}
                <Button
                  size="small"
                  endIcon={<KeyboardArrowRightIcon />}
                  sx={{ fontWeight: "bold", ml: "12px" }}
                  onClick={() => {
                    navigate("/contact/sales");
                  }}
                >
                  Contact sales
                </Button>
              </Box>
            </Box>
          </Box>
          <Box
            className="hero-graphics-container"
            sx={{ m: { xs: "32px auto -56vmin", md: "0 0 0 48px" } }}
          >
            <Box
              className="phone-frame"
              sx={{
                aspectRatio: "264/540",
                width: { xs: "80vmin", md: "264px" },
                padding: { xs: "2.424242424242424vmin", md: "8px" }, // 8px
                borderRadius: { xs: "11.51515151515151vmin", md: "38px" }, // 38px
              }}
            >
              <Box
                className="phone-screen"
                sx={{
                  borderRadius: { xs: "9.393939393939393vmin", md: "31px" }, // 31px
                }}
              >
                {" "}
                <img
                  src={
                    isDarkTheme
                      ? "/images/spidipay-checkout-dark.webp"
                      : "/images/spidipay-checkout-light.webp"
                  }
                  alt="Checkout"
                  style={{
                    width: "100%",
                    overflow: "hidden",
                  }}
                />
              </Box>
            </Box>
            {/* 
            <Box className="hero-dashboard">
              <img
                src={
                  isDarkTheme
                    ? "/images/dashboard-dark.png"
                    : "/images/dashboard-light.png"
                }
                alt="Checkout"
                style={{
                  width: "100%",
                  overflow: "hidden",
                }}
              />
            </Box>
             */}
          </Box>
        </Box>
        <Box
          sx={{
            background: isDarkTheme ? "#303134" : "#f2f6fc",
            boxShadow: isDarkTheme
              ? "0px 0px 0px 100vmax #303134"
              : "0px 0px 0px 100vmax #f2f6fc",
            clipPath: "inset(0 -100vmax)",
            padding: "18px 0",
            margin: "48px 0",
            zIndex: 11,
            position: "relative",
          }}
        >
          <Typography
            variant="h3"
            sx={{
              mt: "48px",
              mb: "72px",
              /* fontSize: "1.1rem", */
              textAlign: "center",
              letterSpacing: "-0.02em",
            }}
          >
            Accepted Payment Methods
          </Typography>
          <Box
            sx={{
              display: "grid",
              grid: {
                xs: "auto/repeat(3,1fr)",
                sm: "auto/repeat(5,1fr)",
                lg: "auto/repeat(7,1fr)",
              },
              gridColumnGap: "16px",
              gridRowGap: "50px",
              mt: "48px",
              mb: "60px",
            }}
          >
            <Box
              sx={{
                background: methodBackground,
                padding: "4px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={"/images/visa-logo.svg"}
                alt="Visa"
                style={{
                  width: "100%",
                  height: methodLogoHeight,
                }}
              />
            </Box>

            <Box
              sx={{
                background: methodBackground,
                padding: "4px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/mastercard-logo.svg"}
                alt="Mastercard"
                style={{ width: "100%", height: "100%" }}
              />
            </Box>

            <Box
              sx={{
                margin: "0 auto",
              }}
            >
              <img
                src={"/images/orange-logo.svg"}
                alt="Orange"
                style={{
                  width: methodLogoHeight,
                  height: methodLogoHeight,
                  borderRadius: methodLogoRadius,
                  overflow: "hidden",
                }}
              />
            </Box>

            <Box sx={{ margin: "0 auto" }}>
              <img
                src={"/images/mtn-logo.svg"}
                alt="MTN"
                style={{
                  width: methodLogoHeight,
                  height: methodLogoHeight,
                  borderRadius: methodLogoRadius,
                  overflow: "hidden",
                }}
              />
            </Box>

            <Box
              sx={{
                background: methodBackground,
                padding: "8px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                display: "flex",
                alignItems: "center",
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/airtel-logo.svg"}
                alt="Airtel"
                style={{
                  width: "100%",
                  height: methodLogoHeight,
                }}
              />
            </Box>
            <Box
              sx={{
                background: methodBackground,
                padding: "4px",
                display: "flex",
                alignItems: "center",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/free-logo.svg"}
                alt="Free"
                style={{ width: "100%", height: "26px" }}
              />
            </Box>

            <Box
              sx={{
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
              }}
            >
              <img
                src={"/images/wave-logo.png"}
                alt="Wave"
                style={{
                  width: "100%",
                  height: "100%",
                  borderRadius: methodLogoRadius,
                  overflow: "hidden",
                }}
              />
            </Box>

            {/* 
            <Box
              className="google"
              sx={{ display: 'flex', alignItems: 'center' }}
            >
              <img
                src={'/images/google-logo.svg'}
                alt="google"
                style={{ width: '100%', height: '24px' }}
              />
            </Box>
             */}

            <Box
              sx={{
                background: "#0d47a1",
                padding: "4px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={"/images/ecobank-logo.svg"}
                alt="Ecobank"
                style={{
                  marginTop: "-4px",
                }}
              />
            </Box>

            <Box
              sx={{
                background: methodBackground,
                padding: "4px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
                display: "flex",
                alignItems: "center",
              }}
            >
              <img
                src={"/images/maestro-logo.svg"}
                alt="Maestro"
                style={{
                  width: "100%",
                  height: methodLogoHeight,
                }}
              />
            </Box>

            <Box>
              <Box
                sx={{
                  background: methodBackground,
                  width: methodLogoHeight,
                  height: methodLogoHeight,
                  margin: "0 auto",
                  padding: "7px",
                  borderRadius: methodLogoRadius,
                  overflow: "hidden",
                  display: "flex",
                  alignItems: "center",
                }}
              >
                <img
                  src={"/images/jcb-logo.svg"}
                  alt="JCB"
                  style={{
                    width: "100%",
                    height: methodLogoHeight,
                  }}
                />
              </Box>
            </Box>

            <Box
              sx={{
                background: methodBackground,
                padding: "3px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/diners-club-logo.svg"}
                alt="Diners Club"
                style={{
                  width: "100%",
                }}
              />
            </Box>

            <Box
              sx={{
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/american-express-logo.svg"}
                alt="American Express"
                style={{
                  width: "100%",
                  height: methodLogoHeight,
                }}
              />
            </Box>

            <Box
              sx={{
                background: methodBackground,
                padding: "3px",
                width: methodLogoHeight,
                height: methodLogoHeight,
                margin: "0 auto",
                display: "flex",
                alignItems: "center",
                borderRadius: methodLogoRadius,
                overflow: "hidden",
              }}
            >
              <img
                src={"/images/discover-logo.svg"}
                alt="Discover"
                style={{
                  width: "100%",
                }}
              />
            </Box>
          </Box>
        </Box>
        <Box sx={{ mb: "72px", textAlign: "center" }}>
          {/*           <Typography
            variant="h3"
            sx={{ fontSize: { md: "48px", sm: "36px", xs: "24px" } }}
          >
            Clean UI, full of data
          </Typography> */}
          {/* 
          <Typography variant="subtitle1">Clean UI, full of data</Typography>
           */}
          <Box
            className="tablet-frame"
            sx={{
              width: { lg: "calc(90vmin * 1.33)", sm: "500px", xs: "90vw" },
              margin: "24px auto",
              padding: { lg: "2px", sm: "1.7px", xs: "0.3vw" },
              borderRadius: { lg: "34px", sm: "20px", xs: "13px" },
            }}
          >
            <Box
              className="tablet-front"
              sx={{
                margin: "0 auto",
                padding: { lg: "20px", sm: "12px", xs: "2.2vmin" },
                borderRadius: { lg: "32px", sm: "18px", xs: "11px" },
              }}
            >
              <Box
                className="tablet-screen"
                sx={{
                  borderRadius: { lg: "11px", sm: "6px", xs: "4px" },
                  overflow: "hidden",
                  background: isDarkTheme ? "#202020" : "#f2f6fc",
                }}
              >
                <img
                  src={
                    isDarkTheme
                      ? "/images/spidipay-dashboard-dark.webp"
                      : "/images/spidipay-dashboard-light.webp"
                  }
                  alt="Dashboard"
                  style={{
                    width: "100%",
                    overflow: "hidden",
                  }}
                />
              </Box>
            </Box>
          </Box>
        </Box>

        <Box>
          <Box
            sx={{
              background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)",
              padding: "18px 0",
              margin: "48px 0 0",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                mt: "48px",
                textAlign: "center",
                letterSpacing: "-0.02em",
              }}
            >
              International
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                display: "grid",
                grid: {
                  xs: "auto/repeat(1,1fr)",
                  sm: "auto/repeat(3,1fr)",
                  lg: "auto/repeat(3,1fr)",
                },
                gridColumnGap: "24px",
                gridRowGap: "50px",
                mt: "48px",
                mb: "48px",
              }}
            >
              <Box>
                <PaymentsOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Multichannel</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  All the major payment methods, bank cards, mobile money and
                  wallet systems are supported.
                </Typography>
              </Box>
              <Box>
                <CurrencyExchangeIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Multicurrency</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  152 fiat currencies are supported from around the world.
                </Typography>
              </Box>
              <Box>
                <LanguageOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Multilanguage</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  User preference following user interface language.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              /*               background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)", */
              padding: "18px 0",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                mt: "48px",
                textAlign: "center",
                letterSpacing: "-0.02em",
              }}
            >
              Unrivaled Convenience
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                display: "grid",
                grid: {
                  xs: "auto/repeat(1,1fr)",
                  sm: "auto/repeat(3,1fr)",
                  lg: "auto/repeat(4,1fr)",
                },
                gridColumnGap: "24px",
                gridRowGap: "50px",
                mt: "48px",
                mb: "48px",
              }}
            >
              <Box>
                <InsightsOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Dashboard</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  All business performance data is clearly visualized with
                  charts, statistics and insights.
                </Typography>
              </Box>
              <Box>
                <UndoIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Refunds</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Full and partial refunds, protected by two-factor
                  authorization.
                </Typography>
              </Box>
              <Box>
                <ReceiptOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Invoicing</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Tax agency compliant invoices generated of the purchase and
                  refund transactions.
                </Typography>
              </Box>
              <Box>
                <PriceCheckOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Tax compliance</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Real time transaction reporting to the tax agencies.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)",
              padding: "18px 0",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                mt: "48px",
                textAlign: "center",
                letterSpacing: "-0.02em",
              }}
            >
              Superb User Experience
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                display: "grid",
                grid: {
                  xs: "auto/repeat(1,1fr)",
                  sm: "auto/repeat(3,1fr)",
                  lg: "auto/repeat(3,1fr)",
                },
                gridColumnGap: "24px",
                gridRowGap: "50px",
                mt: "48px",
                mb: "48px",
              }}
            >
              <Box>
                <TaskOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Clean UI</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  {" "}
                  The cleanest possible modern user interfaces.
                </Typography>
              </Box>
              <Box>
                <DevicesIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Multiplatform</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Fully optimized for every platform, screen size and
                  orientation.
                </Typography>
              </Box>
              <Box>
                <BrightnessMediumOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Multi theme</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  {" "}
                  User preference following user interface colors.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              /*               background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)", */
              padding: "18px 0",
              mt: "48px",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                textAlign: "center",
                letterSpacing: "-0.02em",
              }}
            >
              High Level of Security
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                display: "grid",
                grid: {
                  xs: "auto/repeat(1,1fr)",
                  sm: "auto/repeat(3,1fr)",
                  lg: "auto/repeat(3,1fr)",
                },
                gridColumnGap: "24px",
                gridRowGap: "50px",
                mt: "48px",
                mb: "48px",
              }}
            >
              <Box>
                <LockOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">2FA</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Two-factor authentication and authorization ensures the
                  highest security.
                </Typography>
              </Box>

              <Box>
                <VerifiedUserOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Fraud detection</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Seamless fraud detection prevents malicious software from
                  engaging in abusive activities.
                </Typography>
              </Box>
              <Box>
                <GoogleIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">Sign in with Google</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Industry leading secure user authentication with Google.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box>
          <Box
            sx={{
              background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)",
              padding: "18px 0",
            }}
          >
            <Typography
              variant="h3"
              sx={{
                mt: "48px",
                textAlign: "center",
                letterSpacing: "-0.02em",
              }}
            >
              High Reliability
            </Typography>
            <Box
              sx={{
                textAlign: "center",
                display: "grid",
                grid: {
                  xs: "auto/repeat(1,1fr)",
                  sm: "auto/repeat(3,1fr)",
                  lg: "auto/repeat(3,1fr)",
                },
                gridColumnGap: "24px",
                gridRowGap: "50px",
                mt: "48px",
                mb: "48px",
              }}
            >
              <Box>
                <QueryStatsIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">App monitoring</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Real time app monitoring ensures that our team is notified and
                  can act instantly in case of an issue.
                </Typography>
              </Box>
              <Box>
                <CheckCircleOutlinedIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">High availability</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  The elimination of single points of failure ensures normal
                  operation even in case of an issue.
                </Typography>
              </Box>
              <Box>
                <HeightIcon sx={{ fontSize: "36px" }} />
                <Typography variant="h6">High scalability</Typography>
                <Typography sx={{ mt: 1.5 }}>
                  Ability to increase and decrease in performance in response to
                  changes in demand.
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
        <Box sx={{ mt: "48px", mb: "72px", textAlign: "center" }}>
          <Typography variant="h3">Competitive Pricing</Typography>

          <TableContainer
            component={Paper}
            sx={{
              maxWidth: 600,
              margin: "32px auto",
              background: isDarkTheme ? "#303134" : "#f2f6fc",
            }}
          >
            <Table aria-label="simple table">
              {/*               <TableHead>
                <TableRow>
                  <TableCell sx={{ fontSize: "1rem" }}>Fee category</TableCell>
                  <TableCell align="right" sx={{ fontSize: "1rem" }}>
                    Amount
                  </TableCell>
                </TableRow>
              </TableHead> */}
              <TableBody>
                {rows.map((row) => (
                  <TableRow
                    key={row.name}
                    sx={{
                      "&:last-child td, &:last-child th": { border: 0 },
                    }}
                  >
                    <TableCell
                      component="th"
                      scope="row"
                      sx={{ fontSize: "1rem" }}
                    >
                      {row.name}
                    </TableCell>
                    <TableCell align="right" sx={{ fontSize: "1rem" }}>
                      {row.amount}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </Box>
        <Box>
          <Box
            sx={{
              background: isDarkTheme ? "#303134" : "#f2f6fc",
              boxShadow: isDarkTheme
                ? "0px 0px 0px 100vmax #303134"
                : "0px 0px 0px 100vmax #f2f6fc",
              clipPath: "inset(0 -100vmax)",
              padding: "18px 0",
              textAlign: "center",
            }}
          >
            <Button
              size="large"
              variant="contained"
              /* endIcon={<KeyboardArrowRightIcon />} */
              sx={{ m: "48px 0 72px" }}
              onClick={() => {
                navigate("/contact/sales");
              }}
            >
              Contact sales
            </Button>
          </Box>
        </Box>
      </Box>
    </Box>
  );
};

export default FrontPage;
